// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-templates-profile-landing-page-demolition-js": () => import("./../../../src/templates/profile-landing-page-demolition.js" /* webpackChunkName: "component---src-templates-profile-landing-page-demolition-js" */),
  "component---src-templates-search-apollo-js": () => import("./../../../src/templates/search-apollo.js" /* webpackChunkName: "component---src-templates-search-apollo-js" */)
}

